module.exports = "/_next/static/images/1dbbd9b52f522f9f033ad59325241b50-product-information-md-1x.jpg";